import { jsx as k, Fragment as q, jsxs as x } from "react/jsx-runtime";
import { PrimaryButtonLabel as Y, TimePickerModal as j, TimeMeridiem as w } from "./components/DatePicker/types/enums.js";
import { DAY_LIMIT as T } from "./components/DatePicker/types/propTypes.js";
import './assets/CalendarHelper.css';const U = "#ffffff", X = "#396e75", J = "#e5fdff", K = "#546223", Q = "#f0fae5", Z = "#a65523", ee = "#fff1e8", te = "#7f3e3e", ne = "#ffe2e2", ae = "#62625a", re = "#f8f8e7", se = "#38539a", oe = "#707070", ie = "#c8f8d1", le = "#87c9c8", ce = "#5291b1", de = "rgba(82, 145, 177, 0.1019607843)", ue = "#445685", fe = "#181d61", _e = "rgba(24, 29, 97, 0.1019607843)", ge = "#5969d6", me = "#ea999d", he = "#b6577e", be = "rgba(182, 87, 126, 0.1019607843)", pe = "#7e3e80", De = "#1e247f", Me = "rgba(30, 36, 127, 0.1019607843)", we = "#da7600", ye = "#107f47", Ce = "#d91734", ke = "_html_1saf4_46", ve = "_divider_1saf4_247", g = {
  amwayWhite: U,
  darkBlue: X,
  lightBlue: J,
  darkGreen: K,
  lightGreen: Q,
  darkOrange: Z,
  lightOrange: ee,
  darkRed: te,
  lightRed: ne,
  darkYellow: ae,
  lightYellow: re,
  darkPurple: se,
  darkGrayOnWhite: oe,
  dataVizColor1: ie,
  dataVizColor2: le,
  dataVizColor3: ce,
  dataVizColor3Background: de,
  dataVizColor4: ue,
  dataVizColor5: fe,
  dataVizColor5Background: _e,
  dataVizColor6: ge,
  dataVizColor7: me,
  dataVizColor8: he,
  dataVizColor8Background: be,
  dataVizColor9: pe,
  dataVizColor10: De,
  dataVizColor10Background: Me,
  dataVizAlertOrange: we,
  dataVizSuccessGreen: ye,
  dataVizWarningRed: Ce,
  "no-visible": "_no-visible_1saf4_42",
  html: ke,
  "calendar-container": "_calendar-container_1saf4_80",
  "theme-action": "_theme-action_1saf4_85",
  "month-container": "_month-container_1saf4_85",
  "disabled-nav-btn": "_disabled-nav-btn_1saf4_85",
  "navigation-month-year": "_navigation-month-year_1saf4_88",
  "navigate-year-dropdown-container": "_navigate-year-dropdown-container_1saf4_91",
  "navigation-container": "_navigation-container_1saf4_95",
  "navigation-left": "_navigation-left_1saf4_95",
  "navigation-right": "_navigation-right_1saf4_96",
  "dates-container": "_dates-container_1saf4_104",
  "week-day-sequence": "_week-day-sequence_1saf4_104",
  "selected-cell": "_selected-cell_1saf4_104",
  "date-cell": "_date-cell_1saf4_104",
  "theme-purple": "_theme-purple_1saf4_107",
  "theme-orange": "_theme-orange_1saf4_129",
  "show-calendar-title-only": "_show-calendar-title-only_1saf4_154",
  "date-sequence": "_date-sequence_1saf4_154",
  "heading-cell": "_heading-cell_1saf4_154",
  "navigate-year-dropdown": "_navigate-year-dropdown_1saf4_91",
  "day-sequence": "_day-sequence_1saf4_220",
  "day-cell": "_day-cell_1saf4_227",
  divider: ve,
  "base-date-cell": "_base-date-cell_1saf4_257",
  "selectable-cell": "_selectable-cell_1saf4_269",
  "disabled-cell": "_disabled-cell_1saf4_273",
  "scheduled-event-date": "_scheduled-event-date_1saf4_288",
  "selected-cell-from": "_selected-cell-from_1saf4_291",
  "selected-cell-to": "_selected-cell-to_1saf4_296",
  "selected-range-cell": "_selected-range-cell_1saf4_301",
  "range-left": "_range-left_1saf4_313",
  "range-right": "_range-right_1saf4_317",
  "time-container": "_time-container_1saf4_344",
  "time-dropdown": "_time-dropdown_1saf4_351",
  "time-value-label": "_time-value-label_1saf4_351",
  "time-value-divider": "_time-value-divider_1saf4_362",
  "base-dropdown-result": "_base-dropdown-result_1saf4_371",
  "open-dropdown-result": "_open-dropdown-result_1saf4_371",
  "time-icon": "_time-icon_1saf4_377",
  "time-label": "_time-label_1saf4_380",
  "modal-time-container": "_modal-time-container_1saf4_390",
  "dropdown-box": "_dropdown-box_1saf4_393",
  "calendar-modal-header": "_calendar-modal-header_1saf4_400",
  "icon-close": "_icon-close_1saf4_409",
  "skeleton-loading": "_skeleton-loading_1saf4_1"
}, I = 12, Ae = (e, t) => {
  const n = [];
  for (let a = 0; a < e.length; a += t)
    n.push({ id: a, name: e.slice(a, a + t) });
  return n;
}, Le = (e = 15, t = !0, n = 0, a = !1, r) => {
  const s = [], o = /* @__PURE__ */ new Date();
  for (let d = 0; d < 24; d++)
    for (let _ = 0; _ < 60; _ += e)
      s.push([(d + n) % 24, _]);
  const l = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: t
  }), c = r ? new Date(r) : new Date(o), f = c.getDate() === o.getDate() && c.getMonth() === o.getMonth() && c.getFullYear() === o.getFullYear();
  return s.map(([d, _]) => {
    const m = new Date(c);
    m.setHours(d, _, 0, 0);
    const i = l.format(m), D = o.getHours() * 60 + o.getMinutes(), b = d * 60 + _, v = f && a && b < D;
    return { id: i, name: i, isDisabled: v };
  });
}, Ge = (e) => {
  const t = [];
  let n = 0, a = 12;
  e && (n = 0, a = 24);
  for (let r = n; r < a; r++) {
    const s = `${String(!e && r === 0 ? a : r).padStart(2, "0")}:00`;
    t.push({ id: s, name: s });
  }
  return t;
}, O = (e, t, n) => new Date(e, t, n).getTime(), h = (e) => O(e.getFullYear(), e.getMonth(), e.getDate()), Re = (e, t, n) => e === "left" ? t - (n === 0 ? 1 : 0) : t + (n === 11 ? 1 : 0), Ee = (e, t) => (t + (e === "left" ? -1 : 1) + I) % I, qe = (e) => e ? g["show-calendar-title-only"] : "", xe = (e) => e ? g["date-row-range"] : "", je = (e, t, n) => e ? t : n, Ve = (e, t, n, a, r) => {
  const s = /* @__PURE__ */ new Date();
  s.setHours(0, 0, 0, 0);
  const o = h(e);
  if (r && r(e))
    return !0;
  const l = () => n ? o < h(s) : !1;
  return a && o > O(e.getFullYear(), e.getMonth(), T) ? !0 : !!(t != null && t.find((c) => c.getTime() === o) || l());
}, ze = (e, t, n) => {
  const a = /* @__PURE__ */ new Date();
  n && a.setFullYear(n);
  const r = t || a;
  e && r.setMonth(0);
  const s = r.getFullYear(), o = r.getMonth(), l = r.getHours(), c = r.getMinutes();
  return {
    year: s,
    month: o,
    date: r,
    monthFirstDay: new Date(s, o, 1),
    monthFirstWeekDay: new Date(s, o, 1).getDay(),
    totalMonthDays: new Date(s, o + 1, 0).getDate(),
    hour: l,
    minute: c
  };
}, Se = (e, t) => (t ? t.find((a) => h(e) === h(a)) : !1) ? /* @__PURE__ */ k("div", { className: g["scheduled-event-date"], "data-testid": "week-span-event-testid", "data-pod-name": "fwk" }) : /* @__PURE__ */ k(q, {}), Ne = (e, t, n, a, r, s, o, l, c, f) => {
  const d = e ? n.toDateString() === e.toDateString() : !1;
  let _ = !1, m = !1, i = "";
  const D = Ve(n, c, l, s, f), b = t || a;
  return o && e && !s && b && (_ = n.toDateString() === b.toDateString(), m = h(e) < h(n) && h(n) < h(b), d && h(e) < h(b) ? i = g["selected-cell-from"] : _ && (i = g["selected-cell-to"]), m && (i = g["selected-range-cell"], r === 0 ? i += ` ${g["range-left"]}` : r === 6 && (i += ` ${g["range-right"]}`))), {
    selectionState: d,
    selectionToState: _,
    isWithinSelectedRange: m,
    rangeCellCls: i,
    isDisabled: D
  };
}, $e = (e, t, n, a) => `${g["base-date-cell"]} ${e && g["selectable-cell"]} ${t ? g["disabled-cell"] : ""} ${n ? g["selected-cell"] : ""} ${a}`, Te = ({
  baseDate: e,
  baseEndDate: t,
  intermediateDate: n,
  intermediateEndDate: a,
  showFullCalendar: r,
  show4WeeksOnly: s,
  handleDateTimeUpdate: o,
  selectRange: l,
  scheduleEventOnDates: c,
  disableDate: f,
  disabledDates: d,
  disabledPastDates: _,
  ariaLabel: m,
  defaultYear: i
}) => {
  const {
    month: D,
    date: b,
    monthFirstDay: v,
    monthFirstWeekDay: N,
    totalMonthDays: V
  } = ze(s, n, i), u = v, $ = N, B = [], P = (() => r ? Math.ceil((V + N) / 7) : 5)() * 7;
  let y = [];
  for (let M = 0; M < P; M++) {
    const C = u.getDate() + 1;
    M === 0 && $ === 0 || (M === 0 ? u.setDate(u.getDate() + (M - $)) : u.getMonth() === D ? C <= V ? u.setDate(C) : (u.setMonth(D + 1), u.setDate(C - V)) : u.setDate(C));
    const W = u.getDay(), { selectionState: A, selectionToState: L, isWithinSelectedRange: G, rangeCellCls: R, isDisabled: F } = Ne(
      e,
      t,
      u,
      a,
      W,
      s,
      l,
      _,
      d,
      f
    ), p = {
      isCurrentMonth: u.getMonth() === b.getMonth(),
      date: new Date(u),
      month: u.getMonth(),
      number: u.getDate(),
      selected: A || L,
      year: u.getFullYear(),
      isWithinSelectedRange: G
    }, E = /* @__PURE__ */ k(
      "button",
      {
        type: "button",
        className: $e(p.isCurrentMonth, F, p.selected, R),
        "aria-label": m,
        ...F ? {} : {
          onClick: (z) => o(z, new Date(p.date), !1),
          onMouseEnter: (z) => o(z, new Date(p.date), !0)
        },
        tabIndex: 0,
        children: /* @__PURE__ */ x("span", { className: g["date-cell"], "data-testid": "week-span-testid", "data-pod-name": "fwk", children: [
          p.number,
          Se(p.date, c)
        ] })
      },
      p.date.toISOString()
    );
    y.push(E), y.length === 7 && (B.push(/* @__PURE__ */ k("div", { className: g["week-day-sequence"], children: y })), y = []);
  }
  return B;
}, Ue = (e, t, n, a, r, s, o, l, c, f, d, _, m) => {
  const i = {
    btnTitle: Y.APPLY,
    btnCB: d,
    isDisable: !0
  };
  if (m !== j.NONE)
    return i.isDisable = !1, i;
  if (t) {
    if (t && t !== e && (!f || s))
      return i.isDisable = !1, i;
  } else
    return i;
  return f && !s ? i : f && s !== r ? (i.isDisable = !1, i) : c && !a ? i : c && a && a !== n && (!f || l) ? (i.isDisable = !1, i) : c && f && !l ? i : c && f && l !== o ? (i.isDisable = !1, i) : {
    btnTitle: Y.CLEAR,
    btnCB: _,
    isDisable: !1
  };
}, Xe = (e, t, n, a, r) => {
  if (a) {
    const [s, o] = e ? a.split(":") : H(a);
    t == null || t.setHours(Number(s)), t == null || t.setMinutes(Number(o));
  }
  if (r) {
    const [s, o] = e ? r.split(":") : H(r);
    n == null || n.setHours(Number(s)), n == null || n.setMinutes(Number(o));
  }
  return { modifiedDate: t, modifiedToDate: n };
}, Be = 2, S = 12, Je = (e, t, n) => {
  if (t) {
    const [a, r] = t.split(":"), [s, o] = r.split(" "), [l, c] = e.split(":"), [f, d] = c.split(" ");
    return n && o === w.AM && d === w.PM ? !1 : Number(l) < Number(a) ? !0 : Number(l) === Number(a) && Number(s) <= Number(f);
  } else
    return !1;
}, Fe = (e, t) => {
  const [n, a] = t.split(" "), r = a || (Number(e) < S ? w.AM : w.PM);
  let s = e;
  return Number(e) === 0 ? s = S.toString() : Number(e) > 12 && (s = (Number(e) - 12).toString().padStart(Be, "0")), `${s}:${n} ${r}`;
}, Ye = (e, t) => {
  const n = e.padStart(2, "0"), a = t.padStart(2, "0");
  return `${n}:${a}`;
}, Ie = (e, t) => {
  if (t) {
    const [n, a] = t.split(":");
    return (e ? Ye : Fe)(n, a);
  }
  return t;
}, Ke = (e, t) => {
  if (t) {
    const [n, a] = t.split(":");
    let r = n;
    const [s, o] = a.split(" ");
    let l = s;
    return l !== "00" && (60 - Number(l) < 30 && (r = String(Number(r) + 1)), l = `00${o ? ` ${o}` : ""}`), Ie(
      e,
      `${r.padStart(2, "0")}:${l}${o ? ` ${o}` : ""}`
    );
  }
}, H = (e) => {
  const [t, n] = e.split(":"), [a, r] = n.split(" ");
  let s = Number(t);
  const o = Number(a);
  return r === w.PM && (s += S), [s, o];
}, Qe = () => {
  const e = (/* @__PURE__ */ new Date()).getFullYear(), t = e, n = e + 6, a = [];
  for (let r = t; r < n; r++)
    a.push({ id: String(r), name: r });
  return a;
};
export {
  Ke as a,
  ze as b,
  Te as c,
  Le as d,
  Ue as e,
  Xe as f,
  Qe as g,
  je as h,
  Ee as i,
  H as j,
  Ge as k,
  Ae as l,
  h as m,
  Re as n,
  qe as o,
  xe as p,
  Ve as q,
  Se as r,
  g as s,
  Ie as t,
  Je as u,
  Fe as v,
  Ye as w
};
//# sourceMappingURL=CalendarHelper-81bc584a.mjs.map
